import { useEffect } from "react";
import { BrowserStorageService } from "@/browser-storage";
import { Menu } from "@/models";
import { useCachedState } from "./use-cached-state";
import { useApiClient } from "./use-api-client";

const storage = new BrowserStorageService<Menu[]>("@/hooks/use-menus");

const apiRequestConfig = {
  url: "layout/menus",
};

export function useMenus(isSignedIn: boolean): Menu[] {
  const [menus, setMenus] = useCachedState(storage);
  const { request, response } = useApiClient(apiRequestConfig);

  useEffect(() => {
    if (isSignedIn) {
      request();
    } else {
      setMenus(null);
    }
  }, [isSignedIn, setMenus, request]);

  useEffect(() => {
    if (response) {
      setMenus(response.data);
    }
  }, [setMenus, response]);

  return menus ?? [];
}
